import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";
import classes from "./Activities.module.css";
import { testUrl } from "../BaseData";

// Backend HTML'dan kelgan rasm URL'larini to'g'irlash
const fixHtml = (html) => {
  if (!html) return "";
  return html
    // 1. Ikkilanib ketgan URL (https://renessans-edu.uzhttps://...)
    .replace(/src="https?:\/\/[^"]*?(https?:\/\/[^"]+)"/g, 'src="$1"')
    // 2. Relative path ("/media/...") → to'liq URL
    .replace(/src="(\/media\/[^"]+)"/g, `src="${testUrl}$1"`)
    // href uchun ham (fayllar, linklar)
    .replace(/href="(\/media\/[^"]+)"/g, `href="${testUrl}$1"`);
};

const GreenRenessansAbout = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;
  const [activityType, setActivityType] = useState(null);
  const [category, setCategory] = useState(null);
  const [activityTypes, setActivityTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const sortSidebarItems = (items) => {
    const navbarOrder = [
      "ilmiy-jarayonlar",
      "ilmiy-kengash",
      "ilmiy-konferensiyalar",
      "journal",
      "ilmiy-maktablar",
      "green-renessans",
      "oquv-va-labaratoriya-bazalari",
      "axborotlashtirish-jarayonlari",
      "yosh-akademiklar",
      "avtorefereat-dissertatsiya",
    ];
    return items.sort((a, b) => {
      const ai = navbarOrder.indexOf(a.short_name);
      const bi = navbarOrder.indexOf(b.short_name);
      if (ai !== -1 && bi !== -1) return ai - bi;
      if (ai !== -1) return -1;
      if (bi !== -1) return 1;
      return 0;
    });
  };

  useEffect(() => {
    setLoading(true);
    setError(null);
    axios
      .get(testUrl + "/api/baseactivity/ilmiy-faoliyat/green-renessans")
      .then((res) => {
        const data = res.data;
        if (data) {
          setCategory(data.category || null);
          const excluded = [
            "amaliyot-shartnomalari",
            "talim-jarayoni-hujjatlari",
            "talim-jarayoni-meyoriy-hujjatlari",
            "oquv-reja-va-syllabus",
          ];
          const types = (data.activities_types || []).filter(
            (t) => !excluded.includes(t.short_name)
          );
          setActivityTypes(sortSidebarItems(types));
          setActivityType(data.activity || null);
        }
      })
      .catch(() => setError("Ma'lumotlarni yuklashda xatolik"))
      .finally(() => setLoading(false));
  }, [i18n.language]);

  if (loading) return <div>Yuklanmoqda...</div>;
  if (error) return <div>{error}</div>;

  const html = fixHtml(
    activityType?.[`site_details_${currentLang}`] ||
    activityType?.site_details_uz ||
    ""
  );

  const currentShort = "green-renessans";

  return (
    <div className={classes["mainContainer"]}>
      <div data-aos="fade-up" className={classes["container"]}>
        <h1 className={classes["page-title"]}>
          {activityType?.[`name_${currentLang}`] || t("Green Renessans")}
        </h1>
        {html ? (
          <div
            className={classes["activity-content"]}
            dangerouslySetInnerHTML={{ __html: html }}
          />
        ) : (
          <p style={{ textAlign: "center", color: "#888" }}>
            {t("Ma'lumot topilmadi")}
          </p>
        )}
      </div>

      <div className={classes.sidebar}>
        <h3>
          {category ? category[`name_${i18n.language}`] : t("categories")}
        </h3>
        <ul>
          {activityTypes.filter(Boolean).map((cat) => (
            <li
              key={cat.id}
              className={cat.short_name === currentShort ? classes.active : ""}
              onClick={() =>
                navigate(
                  `/activity/${category?.short_name}/${cat.short_name}`
                )
              }
            >
              {cat[`name_${i18n.language}`]}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default GreenRenessansAbout;
